export default {
  name: "global",
  store() {
    return {
      isMobileMenuVisible: false,
      isFlyoutVisible: false,
      activeFlyout: null,
      isMinicartVisible: false,
      isPredictiveSearchVisible: false,
      isWindowScrolled: false,
      isShowingPhoto: false,
      currentPhotoURL: null,
      cart: null,
      notification: { show: false },
      init() {
        window.addEventListener(
          "scroll",
          this.onWindowScrollHandler.bind(this),
        );

        this.initLiquidAJaxCart();
      },
      get bodyClasses() {
        let classes = [];

        if (this.isMobileMenuVisible) {
          classes.push("mobile-menu-visible");
        }

        if (this.isShowingPhoto) {
          classes.push("overflow-hidden");
        }

        return classes || "";
      },
      openMobileMenu() {
        this.isMobileMenuVisible = true;
      },
      closeMobileMenu() {
        this.isMobileMenuVisible = false;
      },
      toggleMobileMenu() {
        this.isMobileMenuVisible = !this.isMobileMenuVisible;
      },
      openFlyout(id) {
        if (this.isFlyoutVisible && this.activeFlyout === id) {
          this.closeFlyout();
          return;
        }
        this.activeFlyout = id;
        if (!this.isFlyoutVisible) {
          if (window.Alpine?.nextTick) {
            window.Alpine.nextTick(() => {
              this.isFlyoutVisible = true;
            });
          } else {
            this.isFlyoutVisible = true;
          }
        }
      },
      closeFlyout() {
        this.isFlyoutVisible = false;
      },
      showNotification(ok, message, delay = 3000) {
        this.notification = {
          show: true,
          ok: ok,
          message: message,
        };

        setTimeout(() => (this.notification.show = false), delay);
      },
      showPhoto(url) {
        this.currentPhotoURL = url;
        this.isShowingPhoto = true;

        setTimeout(() => {
          const dialog = document.querySelector("#global-photo-dialog");
          dialog.scrollTo({
            behavior: "auto",
            top: (2000 - window.innerHeight) / 2,
            left: (2000 - window.innerWidth) / 2,
          });
        }, 200);
      },
      closePhoto() {
        this.isShowingPhoto = false;
        setTimeout(() => (this.currentPhotoURL = null), 500);
      },
      initLiquidAJaxCart() {
        document.addEventListener("liquid-ajax-cart:request-end", (event) => {
          const { requestState, cart } = event.detail;

          if (requestState.requestType === "add") {
            if (requestState.responseData?.ok) {
              setTimeout(() => (this.isMinicartVisible = true), 50);
            }
          }

          this.cart = cart;
        });

        // Disable updateOnWindowFocus globally to prevent excessive Shopify API requests and 429 rate limits
        window.liquidAjaxCart.conf("updateOnWindowFocus", false);

        if (window.location.href.includes("/cart")) {
          document.addEventListener("liquid-ajax-cart:request-start", () => {
            this.notification.show = false;
          });

          document.addEventListener("liquid-ajax-cart:request-end", (event) => {
            const { requestState } = event.detail;
            const ok = requestState?.responseData?.ok;

            this.showNotification(
              ok,
              ok
                ? "Cart is updated!"
                : requestState?.responseData?.body?.message,
            );
          });
        } else {
          // Only handle error
          document.addEventListener("liquid-ajax-cart:request-end", (event) => {
            const { requestState } = event.detail;
            const ok = requestState?.responseData?.ok;

            if (!ok) {
              this.showNotification(
                false,
                requestState?.responseData?.body?.message,
              );
            }
          });
        }
      },
      onWindowScrollHandler() {
        const isScrolled = window.scrollY > 0;

        this.isWindowScrolled = isScrolled;
        document.body.classList[isScrolled ? "add" : "remove"]("scrolled");
      },
      initSlides(swiperEl) {
        swiperEl.addEventListener("swiperslidechangetransitionend", (event) => {
          const { activeIndex, previousIndex } = event.detail[0];
          const activeSlide = swiperEl.swiper.slides[activeIndex];
          activeSlide.querySelectorAll("video").forEach((v) => v.play());

          const prevSlide = swiperEl.swiper.slides[previousIndex];
          prevSlide.querySelectorAll("video").forEach((v) => v.pause());
        });
      },
      initProductGallery(swiperEl) {
        swiperEl.addEventListener("swiperslidechange", (event) => {
          const { activeIndex, previousIndex } = event.detail[0];
          const activeSlide = swiperEl.swiper.slides[activeIndex];
          activeSlide
            .querySelectorAll(".video-button")
            .forEach((v) => v.click());

          const prevSlide = swiperEl.swiper.slides[previousIndex];
          prevSlide
            .querySelectorAll(".video-button.playing")
            .forEach((v) => v.click());

          window.scrollTo({ top: 0, behavior: "smooth" });
        });
      },
      initSwiperProducts(swiperEl) {
        const autoplayEnabled = swiperEl.dataset.autoplay == "true";

        Object.assign(swiperEl, {
          autoplay: {
            enabled: autoplayEnabled,
            pauseOnMouseEnter: true,
            delay: 1,
          },
          centeredSlides: true,
          parallax: true,
          speed: autoplayEnabled ? 4000 : 300,
          freeMode: {
            enabled: autoplayEnabled,
          },
          spaceBetween: 4,
          slidesPerView: 1.3,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
          navigation: !autoplayEnabled,
          loop: true,
          breakpoints: {
            640: {
              slidesPerView: 1.3,
            },
            768: {
              slidesPerView: 3.3,
            },
            1024: {
              slidesPerView: 4.3,
            },
            1280: {
              slidesPerView: 5.3,
            },
            1536: {
              slidesPerView: 6.3,
            },
          },
        });
        swiperEl.initialize();
      },
      scrollToReveal() {
        return {
          lastScrollY: window.scrollY,
          translateY: 0,
          scroll() {
            const scrollY = window.scrollY;
            const height = this.$refs.navbar.offsetHeight;

            if (Math.abs(scrollY - this.lastScrollY) > 10) {
              this.$store.global.isPredictiveSearchVisible = false;
            }

            if (scrollY <= 0) {
              this.translateY = 0;
            } else if (
              scrollY >
              document.documentElement.scrollHeight - window.innerHeight
            ) {
              // Ignore iOS rubber banding at the bottom
            } else {
              const delta = scrollY - this.lastScrollY;
              this.translateY = Math.max(
                -height,
                Math.min(0, this.translateY - delta),
              );
            }

            this.$refs.navbar.style.transform = `translateY(${this.translateY}px)`;
            this.lastScrollY = scrollY;
          },
        };
      },
      productCardScroll(showHint) {
        return {
          hovered: false,
          showHint: showHint,
          activeIndex: 0,
          hoverTimeout: null,
          onScroll(event) {
            const container = event?.target || this.$refs?.scrollContainer;
            if (container && container.clientWidth > 0) {
              this.activeIndex = Math.round(container.scrollLeft / container.clientWidth);
            }
          },
          scrollToIndex(index) {
            clearTimeout(this.hoverTimeout);
            const container = this.$refs?.scrollContainer;
            if (container && container.clientWidth > 0) {
              this.hovered = true;
              container.scrollTo({
                left: index * container.clientWidth,
                behavior: 'smooth'
              });
            }
          },
          init() {
            if (this.showHint) {
              const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                  if (entry.isIntersecting) {
                    observer.disconnect();
                    setTimeout(() => {
                      this.hovered = true;
                      this.$nextTick(() => {
                        const container = this.$refs.scrollContainer;
                        if (container) {
                          container.scrollTo({
                            left: container.clientWidth,
                            behavior: "smooth"
                          });
                          setTimeout(() => {
                            container.scrollTo({
                              left: 0,
                              behavior: "smooth"
                            });
                          }, 1000);
                        }
                      });
                    }, 1000);
                  }
                });
              }, { threshold: 0.1 });
              observer.observe(this.$el);
            }
          },
          startHover(delay = 300) {
            if (!window.matchMedia('(hover: hover)').matches) return;
            clearTimeout(this.hoverTimeout);
            this.hoverTimeout = setTimeout(() => {
              this.hovered = true;
              const container = this.$refs?.scrollContainer;
              if (container) {
                container.scrollTo({
                  left: container.clientWidth,
                  behavior: 'smooth'
                });
              }
            }, delay);
          },
          stopHover() {
            clearTimeout(this.hoverTimeout);
            if (!window.matchMedia('(hover: hover)').matches) return;
            const container = this.$refs?.scrollContainer;
            if (container && container.scrollLeft > 0) {
              container.scrollTo({
                left: 0,
                behavior: 'smooth'
              });
            }
          }
        };
      },
      togglePlayback(el) {
        if (el.tagName === "VIDEO") {
          if (window.getComputedStyle(el, null).display === "none") {
            el.pause();
          } else if (el.paused) {
            el.play();
          }
        } else {
          console.warn(el, "should not be using this callback");
        }
      },
    };
  },
};
